import React, { useEffect, useState } from 'react';
import { auth } from './firebase';
import { listarListas, crearLista as crearListaApi, eliminarLista as eliminarListaApi } from './api/listas';
import './MisListas.css';
import { Link } from 'react-router-dom';
import { Heart, Folder, Plus, Trash2 } from 'lucide-react';
import CarLoader from './components/CarLoader';

function MisListas() {
  const [listas, setListas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [nuevaLista, setNuevaLista] = useState('');
  const [nuevaDescripcion, setNuevaDescripcion] = useState('');

  const cargarListas = async () => {
    const user = auth.currentUser;
    if (!user) return;
    setCargando(true);
    try {
      setListas(await listarListas());
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargarListas(); }, []);

  const crearLista = async () => {
    const nombre = nuevaLista.trim();
    if (!nombre) return;
    const user = auth.currentUser;
    if (!user) return;
    await crearListaApi(nombre, (nuevaDescripcion || '').trim());
    setNuevaLista('');
    setNuevaDescripcion('');
    cargarListas();
  };

  const eliminarLista = async (id) => {
    const user = auth.currentUser;
    if (!user) return;
    await eliminarListaApi(id);
    cargarListas();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') crearLista();
  };

  return (
    <div className="listas-main">
      <div className="listas-wrapper">

        {/* Título */}
        <div className="listas-page-title">
          <div className="listas-page-icon">
            <Heart size={18} />
          </div>
          <div>
            <h1 className="listas-page-heading">Mis proyectos</h1>
            <p className="listas-page-sub">Arma tu propio análisis: agrega modelos, compará precios y llevá tu seguimiento manual sin afectar el catálogo general</p>
          </div>
        </div>

        {/* Crear nuevo proyecto */}
        <div className="listas-create-card">
          <div className="listas-create-label">Nuevo proyecto</div>
          <div className="listas-create-row">
            <input
              type="text"
              placeholder="Nombre del proyecto"
              value={nuevaLista}
              onChange={e => setNuevaLista(e.target.value)}
              onKeyDown={handleKeyDown}
              className="listas-input"
            />
            <input
              type="text"
              placeholder="Descripción (opcional)"
              value={nuevaDescripcion}
              onChange={e => setNuevaDescripcion(e.target.value)}
              onKeyDown={handleKeyDown}
              className="listas-input listas-input--desc"
            />
            <button
              onClick={crearLista}
              className="listas-create-btn"
              disabled={!nuevaLista.trim()}
            >
              <Plus size={15} /> Crear proyecto
            </button>
          </div>
        </div>

        {/* Listado */}
        {cargando ? (
          <div className="listas-empty">
            <CarLoader label="Cargando proyectos…" />
          </div>
        ) : listas.length === 0 ? (
          <div className="listas-empty">
            <div className="listas-empty-icon">
              <Folder size={24} />
            </div>
            <p>No tienes proyectos creados aún.</p>
            <span className="listas-empty-hint">Crea tu primer proyecto arriba para guardar y comparar modelos.</span>
          </div>
        ) : (
          <>
            <p className="listas-count">
              <strong>{listas.length}</strong> proyecto{listas.length !== 1 ? 's' : ''}
            </p>

            <ul className="listas-ul">
              {listas.map(lista => (
                <li key={lista.id} className="lista-item">
                  <div className="lista-info">
                    <Link
                      to={`/mis-listas/${encodeURIComponent(lista.id)}`}
                      className="lista-link"
                      title="Abrir proyecto"
                    >
                      <div className="lista-link-icon">
                        <Folder size={15} />
                      </div>
                      <span className="lista-nombre">
                        {lista.nombre || lista.id}
                      </span>
                    </Link>

                    <div className="lista-meta">
                      {lista.descripcion && (
                        <span className="lista-descripcion">{lista.descripcion}</span>
                      )}
                      {lista.autosCount > 0 && (
                        <span className="lista-autos-count">
                          {lista.autosCount} auto{lista.autosCount !== 1 ? 's' : ''}
                        </span>
                      )}
                    </div>
                  </div>

                  <button
                    onClick={() => eliminarLista(lista.id)}
                    className="btn-eliminar"
                    title="Eliminar proyecto"
                  >
                    <Trash2 size={13} /> Eliminar
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}

      </div>
    </div>
  );
}

export default MisListas;